(function () {
  // Aan/uit via shop metafield (data-availability-sort op <html>)
  const enabled = document.documentElement.dataset.availabilitySort === "true";
  if (!enabled) return;
  if (!window.location.pathname.includes("/collections/")) return;

  const GRID_SELECTOR = "#product-grid, .collection-grid, .product-grid, ul.grid";
  const SOLD_OUT_SELECTOR =
    "[data-sold-out], .sold-out, .badge--sold-out, .price--sold-out";

  function userChoseSort() {
    // Een door de bezoeker gekozen sortering (bijv. prijs) niet overschrijven
    return new URLSearchParams(window.location.search).has("sort_by");
  }

  function isSoldOut(card) {
    return !!card.querySelector(SOLD_OUT_SELECTOR);
  }

  function sortGrid(grid) {
    if (userChoseSort()) return;

    const cards = [...grid.children];
    if (cards.length < 2) return;

    const available = cards.filter((c) => !isSoldOut(c));
    const soldOut = cards.filter(isSoldOut);
    if (!soldOut.length || !available.length) return;

    // Alleen herschikken als de volgorde echt anders is (voorkomt onnodige DOM-mutaties)
    const desired = [...available, ...soldOut];
    if (desired.every((c, i) => c === cards[i])) return;

    const fragment = document.createDocumentFragment();
    desired.forEach((c) => fragment.appendChild(c));
    grid.appendChild(fragment);
  }

  let observer = null;
  let observedGrid = null;

  function run() {
    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;

    // Observer tijdelijk uit, zodat onze eigen herschikking geen nieuwe run triggert
    if (observer) observer.disconnect();
    sortGrid(grid);

    if (!observer) observer = new MutationObserver(run);
    observedGrid = grid;
    observer.observe(observedGrid, { childList: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  // Dawn vervangt de hele grid bij filteren/sorteren → opnieuw koppelen
  document.addEventListener("shopify:section:load", run);
  const container = document.getElementById("ProductGridContainer");
  if (container) {
    new MutationObserver(() => {
      const grid = document.querySelector(GRID_SELECTOR);
      if (grid && grid !== observedGrid) run();
    }).observe(container, { childList: true, subtree: true });
  }
})();
